<template>
  <a :href="gig.url">
    <div class="Gig Gig--panel">
      <div class="Gig__date">
        <div class="Gig__date-date">
          {{ (new Date(gig.startsAt)).getDate() }}
        </div>
        <div class="Gig__date-month">
          {{ shortMonths[(new Date(gig.startsAt)).getMonth()] }}
        </div>
      </div>

      <div class="Gig__image-container">
        <img
          v-if="gig.imageUrl"
          :src="gig.imageUrl"
          class="Gig__image"
          :alt="gig.title"
        >
        <div
          v-else
          class="Gig__image-placeholder"
        />
      </div>

      <div class="Gig__details-container" style="-webkit-box-orient: vertical;">
        <div class="Gig__title">
          {{ gig.title }}
        </div>
        <div v-if="gig.venueName" class="Gig__venue">
          {{ gig.venueName }}
        </div>
        <div class="Gig__additional-details">
          <div
            v-if="gig.pricing"
            class="Gig__ticketing Gig__additional-detail"
          >
            <i class="icon icon--ticket" />
            {{ gig.pricing }}
          </div>

          <div
            v-if="gig.genres"
            class="Gig__genres Gig__additional-detail"
          >
            <i class="icon icon--music" />
            {{ gig.genres }}
          </div>
        </div>
      </div>

      <div class="Gig__actions">
        <a
          :href="gig.url + '/add-to-calendar'"
        >
          <i class="icon icon--calendar" />
          Add to calendar
        </a>
      </div>

      <div
        v-if="gig.pick"
        class="Gig__pick-container"
      >
        <div class="Gig__pick">
          <i class="fas fa-star" />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    gig: {
      default: () => {},
      type: Object,
    },
    shortMonths: {
      default: () => ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      type: Array,
    },
  },
};
</script>
